// load websocket library if we are not in the browser
import duplex from './duplex.js';
import WebSocket from './web-socket.js';
import wsurl from './ws-url.js';
export function connect(addr, opts) {
    const location = typeof window === 'undefined' ? '' : window.location;
    opts = opts ?? {};
    const url = wsurl(addr, location.toString());
    const socket = new WebSocket(url, opts.websocket);
    return duplex(socket, opts);
}
//# sourceMappingURL=client.js.map